<template>
  <div id="paymentContainer">
    <v-dialog  max-width="290" v-model="showDialog">
      <v-card>
        <div class="cardTitle">{{ this.getPriceInfo()['text'] }}</div>
        <v-radio-group v-model="selectedPaymentMethod" dense hide-details class="px-5 pb-5">
          <v-radio value="card" label="카드결제" color="primary" class="black--text"></v-radio>
          <v-radio value="accountTransfer" label="무통장입금" color="primary" class="black--text"></v-radio>
        </v-radio-group>


        <div>
          <div style="margin-left: 20px;">결제 기간을 선택해주세요.</div>
          <v-radio-group v-model="selectedPeriodMonth" dense hide-details class="px-5 pb-5">
            <v-radio v-if="selectedProductLevel!=='premium'" value='1' label="1개월(30일)" color="primary" class="black--text"></v-radio>
            <v-radio value='12' label="12개월(365일)" color="primary" class="black--text"></v-radio>
          </v-radio-group>
        </div>

        <v-divider class="py-2"></v-divider>

        <v-card-text v-if="selectedPaymentMethod === 'accountTransfer'">
          <strong>결제 정보</strong>
          <br />하나은행
          <br />103-910061-87204
          <br />(주)데이터노우즈
          <br />
          <br />입금이 완료되면 아래 링크를 통해
          <br />입금 내용을 알려주세요!!
          <br />(예금주, 전화번호, 이메일)
          <br />
          <a target="_blank" href="https://expert-richgo.channel.io/">입금 내용 알리기</a>
        </v-card-text>

        <v-card-text class="caption pb-0">
          ※ 본 서비스는 Google의
          <br />chrome 웹브라우저 사용을 권장합니다.
          <br />※ 서비스 특성상 구매 후 단순 변심,
          <br />취소는 어려우니 유의하시기 바랍니다.
        </v-card-text>

        <v-card-actions>
          <v-btn
              v-if="selectedPaymentMethod === 'card'"
              color="primary"
              text
              @click="requestPayment"
          >결제하기</v-btn>

          <v-btn
              v-else-if="selectedPaymentMethod === 'accountTransfer'"
              color="primary"
              text
              @click="showDialog=false"
          >확인</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div>
      <div id="header" class="paymentContainer">
        <div>
          <div class="headerContainer">
            <div class="headerTitle">
              <div style="font-size:16px;font-weight:300;margin-bottom: 4px">가장 안전하고 똑똑하게,</div>
              <div style="font-size:20px;"><span style="font-weight:bold;">부동산 자산을 늘릴 수 있는 경험</span>을 해보세요</div>
            </div>
            <div style="display: flex; justify-content: center; align-items: center">
              <div class="orderTypeButton clicked">개인용</div>
              <div class="orderTypeButton" @click="goToMas">법인용</div>
            </div>
          </div>
        </div>
        <div style="position: absolute; top:0; left:calc(50% - 130px)">
          <div style="position: absolute">
            <img id="dollarImg" src="../../assets/payment/dollar.png"/>
            <img id="coinImg" src="../../assets/payment/coin.png"/>
          </div>
          <div style="position: absolute">
            <img id="plusImg" src="../../assets/payment/plus.png"/>
            <img id="documentImg" src="../../assets/payment/document.png"/>
          </div>
        </div>
      </div>
      <div id="body" style="background: #F7F8FA">
        <img class="personal_price" src="../../assets/payment/expert_personal_1280.png" @click="onClick">
        <a target="_blank" href="https://expert-richgo.channel.io/">
        </a>
<!--        <div class="paymentContainer bodyContainer">-->
<!--          <div style="margin-top: 14px;display: flex; justify-content: center; -moz-border-radius-topright:20px;-moz-border-radius-topleft: 20px;background:#FBFCFD;box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.08);">-->
<!--            <div style="width: 356px" class="productPrice rightBorder">-->
<!--              <div style="margin-bottom:40px;">기간 및 계정</div>-->
<!--              <div style="margin-bottom:64px;">1개월 / 1계정</div>-->
<!--              <div style="position: relative">-->
<!--                <div class="saleIcon" style="">-->
<!--                  <div style="padding-left:1px;padding-top:3px;position:relative;z-index: 5">30%<br/>할인</div>-->
<!--                </div>-->

<!--                <div style="font-weight: bold;font-size:20px">12개월 / 1계정</div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div style="width: 200px" class="productPrice rightBorder">-->
<!--              <div style="font-weight: 900; line-height: 24px;margin-top:32px;">기본</div>-->
<!--              <div style="margin-top:44px;font-size:18px;line-height: 27px">6만원/월</div>-->
<!--              <div class="originalPrice">72만원</div>-->
<!--              <div style="color:#777777"><span style="color: #000000;font-weight: bold;font-size: 40px;line-height:30px">50</span>만원/년</div>-->
<!--              <div class="servicePaymentButton" @click="onDialog('normal')">서비스 신청</div>-->
<!--            </div>-->
<!--            <div style="width: 200px" class="productPrice rightBorder">-->
<!--              <div style="font-weight: 900; line-height: 24px;margin-top:32px;">고급</div>-->
<!--              <div style="margin-top:44px;font-size:18px;line-height: 27px">9만원/월</div>-->
<!--              <div class="originalPrice">108만원</div>-->
<!--              <div style="color:#777777"><span style="color: #000000;font-weight: bold;font-size: 40px;line-height:30px">75</span>만원/년</div>-->
<!--              <div class="servicePaymentButton" @click="onDialog('advanced')">서비스 신청</div>-->
<!--            </div>-->
<!--            <div style="width: 200px" class="productPrice">-->
<!--              <div style="font-weight: 900; line-height: 24px;margin-top:6px;">프리미엄</div>-->
<!--              <div style="margin-top:34px;font-size:18px;line-height: 27px;margin-bottom:16px;">-</div>-->
<!--              <div style="font-weight: 800;font-size: 17px;line-height: 22px;color: #110400;">🎉 고객감사 이벤트</div>-->
<!--              <div><span style="font-weight: 300;font-size: 16px;line-height: 30px;text-decoration-line: line-through;color: #888888;">220만원</span><span style="margin-left:10px;color: #F24E1E;font-weight: 700;font-size: 12px;line-height: 22px;-->
<!--background: #FEEDE9;-->
<!--border-radius: 4px;padding: 2px 12px;-->
<!--">25% 추가할인</span></div>-->
<!--              <div style="color:#777777;"><span style="color: #F24E1E;font-weight: bold;font-size: 40px;line-height:30px">99</span>만원/년</div>-->
<!--              <div style=" color: #777777;font-weight: 400;font-size: 10px;line-height: 12px;margin-bottom:12px;margin-top:12px;">(부가세 포함, 조기 종료 될 수 있습니다.)</div>-->
<!--              <div class="servicePaymentButton premiumButton" @click="onDialog('premium')">서비스 신청</div>-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="productRow">-->
<!--            <div class="productItemContainer">-->
<!--              <div class="productItemTitle">-->
<!--                <div>지역 종합&nbsp;</div>-->
<!--                <div>시도/시군구별</div>-->
<!--                <div>기본정보</div>-->
<!--              </div>-->
<!--              <div class="productItemDescription">-->
<!--                (지역저평가, 매매전세 수급동향<br/>-->
<!--                입주물량, 미분양, 인구수/세대수, 거래량,<br/>-->
<!--                해당지역 일자리데이터, 시도대출위험지수)<br/>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="productEnable rightBorder">O</div>-->
<!--            <div class="productEnable rightBorder">O</div>-->
<!--            <div class="productEnable premiumEnable">O</div>-->
<!--          </div>-->
<!--          <div class="productRow">-->
<!--            <div class="productItemContainer">-->
<!--              <div class="productItemTitle">-->
<!--                지역저평가-->
<!--              </div>-->
<!--              <div class="productItemDescription">-->
<!--                전세,소득,물가 대비 저평가 INDEX,<br/>-->
<!--                주택구매력지수, 주택구입물량지수,<br/>-->
<!--                전세가율추이, 전세대비저평가순위(읍면동)<br/>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="productEnable rightBorder">O</div>-->
<!--            <div class="productEnable rightBorder">O</div>-->
<!--            <div class="productEnable premiumEnable">O</div>-->
<!--          </div>-->
<!--          <div class="productRow">-->
<!--            <div class="productItemContainer">-->
<!--              <div class="productItemTitle">시세 저평가</div>-->
<!--              <div class="productItemDescription">-->
<!--                단지별 종합 저평가 top 100<br/>-->
<!--                대장아파트 시세비교<br/>-->
<!--                급지별 시세비교<br/>-->
<!--                단지분석</div>-->
<!--            </div>-->
<!--            <div class="productEnable rightBorder">X</div>-->
<!--            <div class="productEnable rightBorder">O</div>-->
<!--            <div class="productEnable premiumEnable">O</div>-->
<!--          </div>-->

<!--          <div class="productRow">-->
<!--            <div class="productItemContainer">-->
<!--              <div class="productItemTitle">-->
<!--                <div style="width:34px;text-align: center;">-->
<!--                  수요<br/>&<br/>공급</div>-->
<!--              </div>-->
<!--              <div class="productItemDescription" style="margin: 28px 0;">-->
<!--                <div style="line-height: 26px; padding-bottom:20px">-->
<!--                  인구수/세대수<br/>-->
<!--                  입주물량<br/>-->
<!--                  미분양<br/>-->
<!--                  수도권 지하철-->
<!--                </div>-->
<!--                <div class="divider"></div>-->
<!--                <div style="line-height: 20px;padding-top:20px">-->
<!--                  아파트 노후도<br/>-->
<!--                  일자리데이터 세부분석<br/>-->
<!--                  매입자별 거주지 거래량/비중 분석<br/>-->
<!--                  규모별 세대수 및 구성비<br/>-->
<!--                  인구수(읍면동)</div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div>-->
<!--              <div style="display: flex; justify-items: center; align-items: center">-->
<!--                <div class="productEnable rightBorder">O</div>-->
<!--                <div class="productEnable rightBorder">O</div>-->
<!--                <div class="productEnable premiumEnable">O</div>-->
<!--              </div>-->
<!--              <div class="divider"></div>-->
<!--              <div style="display: flex; justify-items: center; align-items: center">-->
<!--                <div class="productEnable rightBorder">X</div>-->
<!--                <div class="productEnable rightBorder">O</div>-->
<!--                <div class="productEnable premiumEnable">O</div>-->
<!--              </div>-->
<!--            </div>-->

<!--          </div>-->

<!--          <div class="productRow">-->
<!--            <div class="productItemContainer">-->
<!--              <div class="productItemTitle">매수매도<br/>타이밍</div>-->
<!--              <div class="productItemDescription">-->
<!--                <div style="padding-bottom: 50px">-->
<!--                  실거래량/가격 정보<br/>-->
<!--                  매매전세 수급동향(시도별)-->
<!--                </div>-->
<!--                <div class="divider"></div>-->
<!--                <div style="padding-top:50px">-->
<!--                  매매/전세/월세 매물흐름<br/>-->
<!--                  거래회전율/지역내 거래비중</div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div>-->
<!--              <div style="display: flex; justify-items: center; align-items: center">-->
<!--                <div class="productEnable rightBorder">O</div>-->
<!--                <div class="productEnable rightBorder">O</div>-->
<!--                <div class="productEnable premiumEnable">O</div>-->
<!--              </div>-->
<!--              <div class="divider"></div>-->
<!--              <div style="display: flex; justify-items: center; align-items: center">-->
<!--                <div class="productEnable rightBorder">X</div>-->
<!--                <div class="productEnable rightBorder">O</div>-->
<!--                <div class="productEnable premiumEnable">O</div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="productRow">-->
<!--            <div class="productItemContainer">-->
<!--              <div class="productItemTitle">미래&nbsp;지역전망</div>-->
<!--              <div class="productItemDescription">-->
<!--                <div style="padding-bottom: 50px;">-->
<!--                  <div>-->
<!--                    지역종합투자점수(현시점)<br/>-->
<!--                    상승힘 지수(현시점)-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="divider"></div>-->
<!--                <div style="padding-top: 50px">-->
<!--                  지역종합투자점수(타임머신)<br/>-->
<!--                  상승힘 지수(타임머신)-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div>-->
<!--              <div style="display: flex; justify-items: center; align-items: center">-->
<!--                <div class="productEnable rightBorder">X</div>-->
<!--                <div class="productEnable rightBorder">O</div>-->
<!--                <div class="productEnable premiumEnable">O</div>-->
<!--              </div>-->
<!--              <div class="divider"></div>-->
<!--              <div style="display: flex; justify-items: center; align-items: center">-->
<!--                <div class="productEnable rightBorder">X</div>-->
<!--                <div class="productEnable rightBorder">X</div>-->
<!--                <div class="productEnable premiumEnable">O</div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="productRow">-->
<!--            <div class="productItemContainer">-->
<!--              <div class="productItemTitle">경제</div>-->
<!--              <div class="productItemDescription">-->
<!--                <div>미국,한국 주요 부동산/금융 지표,-->
<!--                  리치고 경기/물가 선행지표</div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="productEnable rightBorder">O</div>-->
<!--            <div class="productEnable rightBorder">O</div>-->
<!--            <div class="productEnable premiumEnable">O</div>-->
<!--          </div>-->

<!--          <div class="productRow">-->
<!--            <div class="productItemContainer">-->
<!--              <div class="productItemTitle">스페셜 토픽</div>-->
<!--              <div class="productItemDescription">-->
<!--                정부정책<br/>-->
<!--                갭투자<br/>-->
<!--                1억/3억 미만 아파트찾기<br/>-->
<!--                +@ (추후 추가가능)</div>-->
<!--            </div>-->
<!--            <div class="productEnable rightBorder">X</div>-->
<!--            <div class="productEnable rightBorder">X</div>-->
<!--            <div class="productEnable premiumEnable">O</div>-->
<!--          </div>-->
<!--          <div style="margin-top:20px;font-size:10px;line-height: 24px;color:#777777;text-align:right">※ 표기된 금액은 VAT가 포함된 금액입니다.</div>-->
<!--        </div>-->

        </div>
      </div>
      <div id="bodyMobile">
        <img class="personal_price" src="../../assets/payment/expert_personal_mobile.png" @click="onClick">
        <a target="_blank" href="https://expert-richgo.channel.io/">
        </a>

      </div>
      <div id="footer">
        <ul class="paymentContainer footerContainer">
          <li style="color:#F24E1E;font-weight:500;line-height: 20px">
            <ul class="footerContent">
              <li>본 서비스는 정보 제공 목적으로 시스템 문제가 아닌 단순 변심, 취소로 환불은 불가능하오니 유의하시기 바랍니다. ‘기본형 월 상품’을 먼저 사용하시는 것을 추천합니다.</li>
              <li>본 서비스는 Google의 chrome 웹 브라우저를 통해서 이용하실 수 있으며, 해상도는 1920 * 1080 에 최적화 되어 있습니다.</li>
              <li>의사 결정으로 인한 모든 손익은 본인에게 있습니다.</li>
              <li>데이터 수집, 정책 변경에 따라 시각화 형태 또는 메뉴 구성이 달라질 수 있습니다.</li>
              <li>구입한 계정은 타인과 공유할 수 없으며 OTP를 통해 접속할 수 있습니다.</li>
              <li>저작권, 계정 불법 공유 등의 불법적인 문제 발생시, 통보 후 서비스 중지가 될 수 있습니다.</li>
              <li>개인용 서비스에서는 데이터 다운로드 기능이 제공되지 않습니다. 별도로 문의해주세요.</li>
              <li>유튜브, 강의 등 기타 목적으로 사용할 경우 별도로 승인을 받아야합니다.</li>

            </ul>
          </li>
          <li>
            <div class="footerTitle">서비스 안내</div>
            <ul class="footerContent">
              <li>서비스 소개 메뉴의 체험하기를 제외한 모든 서비스는 결제 후 이용 가능합니다.</li>
              <li>콘텐츠, 이용 상담 등 자세한 문의 사항은 고객센터로 문의 부탁드립니다.</li>
              <li>영업시간 : 월요일 ~ 금요일 / 10:00 ~ 17:00 / 공휴일 제외</li>
            </ul>
          </li>
          <li>
            <div class="footerTitle">구매안내</div>
            <ul class="footerContent">
              <li>본 서비스의 구입은 리치고  회원 가입 후 본 서비스를 통해서만 사용이 가능합니다.</li>
              <li>안내드린 금액은 부가세 10%가 포함된 가격입니다.</li>
              <li>변경(기본 -> 고급)시, 기존 사용 서비스에 대해 일할 계산으로 환불가능 합니다. 고객센터로 문의해주시기 바랍니다.</li>
              <li>예) 기본 50만원/년 사용 후, 고급 75만원/년으로 변경 시, 고급형 결제 -> 기본형 환불(일할계산)</li>
              <li>첫 번째 월간 결제 후 연간 결제로 변경 건에 대해서는 일주일 내에 의사표시를 해주시면 그 차액만큼 추가 지불하여 사용할 수 있으며, 고객센터로 문의해주시기 바랍니다.</li>
              <li>예) 기본 6만원/월 사용 후, 50만원/년으로 변경 시 44만원 추가 납입</li>
            </ul>
          </li>
          <li>
            <div class="footerTitle">결제 안내</div>
            <ul class="footerContent">
              <li>신용카드 결제 시 별도의 세무 증빙 자료는 발행되지 않으며, 신용카드 결제 전표로 증빙자료를 갈음합니다.</li>
              <li>기업용은 사용하실 회선 수량에 따라 비용이 변동이 되므로 문의해주시기 바랍니다.</li>
            </ul>
          </li>
          <li>
            <div class="footerTitle">저작권 안내</div>
            <ul class="footerContent">
              <li>리치고에서 제공하는 모든 서비스 및 콘텐츠는 상업적으로 강의/SNS 홍보 목적, 복제, 수정 등에 의한 재배포, 출판 등을 금지합니다.</li>
              <li>SNS 블로그, 카페, 메신저 등에서 인용시에 출처를 밝혀 주시기 바랍니다.</li>
              <li>저작권 관련 필요시 당사 담당자에게 문의해주시고, 협의에 의한 재배포의 경우에도 원본자료 출처를 명시해야 합니다.</li>
              <li>이에 대한 사항을 위반할 경우 외부 유출로 인해 야기되는 민형사상의 책임은 당사자 본인이 부담하게 됩니다.</li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
</template>

<script>
import { api } from '../../mixins/api.js'

// const store_code = 'imp97927708'; // dev
const store_code = "imp91369088"; // production

export default {
  name: "ProductComponentV2",
  created() {
    // eslint-disable-next-line no-undef
    IMP.init(store_code);
  },
  data() {
    return {
      selectedProductLevel: "normal",
      selectedPaymentMethod: 'card',
      selectedPeriodMonth: '1',
      showDialog: false,
    }
  },

  methods: {
    goToMas() {
      window.open("https://mas.richgo.ai/");
    },
    onDialog(productLevel) {
      this.selectedProductLevel = productLevel;
      this.selectedPaymentMethod = 'card';
      if (productLevel === 'premium') this.selectedPeriodMonth = '12';
      else this.selectedPeriodMonth = '1';

      this.showDialog = true;
    },
    onClick() {
      alert('결제는 리치고 서비스에서 결제가 됩니다.\n결제 후엔 리치고 부동산 투자 체크리스트 무제한 서비스가 가능하며,\nExpert 서비스를 활성화하기 위한 코드가 발급됩니다.');
      window.open('https://m.richgo.ai/purchase/checklist-pass');
    },
    getPriceInfo() {
      if (this.selectedProductLevel === 'normal' && this.selectedPeriodMonth === '1')
        return { id: 100, price: 60000, text: '개인 - 일반 (1개월), 60,000원' };

      if (this.selectedProductLevel === 'normal' && this.selectedPeriodMonth === '12')
        return { id: 101, price: 500000, text: '개인 - 일반 (12개월), 500,000원' };

      if (this.selectedProductLevel === 'advanced' && this.selectedPeriodMonth === '1')
        return { id: 102, price: 90000, text: '개인 - 고급 (1개월), 90,000원' };

      if (this.selectedProductLevel === 'advanced' && this.selectedPeriodMonth === '12')
        return { id: 103, price: 750000, text: '개인 - 고급 (12개월), 750,000원' };

      // if (this.selectedProductLevel === 'premium' && this.selectedPeriodMonth === '12')
      //   return { id: 104, price: 1500000, text: '개인 - 프리미엄 (12개월), 1,500,000원' };
      if (this.selectedProductLevel === 'premium' && this.selectedPeriodMonth === '12')
        return { id: 105, price: 990000, text: '개인 - 프리미엄 (12개월)[할인], 990,000원' };
    },
    async requestPayment() {
      let productId = this.getPriceInfo()['id'];
      // this.$ga.event(
      //     "서비스 이용하기",
      //     `개인용 서비스 이용 클릭`,
      //     productId === 9 ? '리치고 1년 이용권' : '리포트 6년 이용권 (6회분)'
      // );

      if ((await this.$store.dispatch("updateLoggedin")) === false) {
        alert("로그인이 필요합니다.");
        this.$ga.event("로그인", "로그인 필요", "개인용 서비스 이용하기");

        this.$router.push("/login");
        return;
      }

      const paymentData = await api.methods.requestPaymentApi(productId);
      if (paymentData === null) {
        alert("결제에 실패했습니다. 문의사항이 있으면 고객센터에 연락바랍니다."
        );
        return;
      } else {
        // eslint-disable-next-line
        IMP.request_pay({
          ...paymentData,
          display: { card_quota: [1,2,3,4,5,6,7,8,9,10,11,12] }
        }, async response => {
          if (response.success) {
            // for logging
            // let msg = '결제가 완료되었습니다.';
            // msg += '고유ID : ' + response.imp_uid;
            // msg += '상점 거래ID : ' + response.merchant_uid;
            // msg += '결제 금액 : ' + response.paid_amount;
            // msg += '카드 승인번호 : ' + response.apply_num;
            // alert(msg);

            const refreshResponse = await api.methods.refreshPaymentApi(
                response.merchant_uid
            );
            if (refreshResponse.status === 200) {
              if (refreshResponse.data["accessToken"]) {
                const accessToken = refreshResponse.data["accessToken"];
                this.$store.commit("setAccessToken", accessToken);
              }

              this.$router.push(`/payment/result/${response.merchant_uid}`);
            } else {
              alert("결제 갱신 실패");
            }
          } else {
            // let msg = '결제에 실패하였습니다.';
            // msg += '에러내용 : ' + response.error_msg;

            alert(response.error_msg);
            await api.methods.notificationPaymentApi(response.merchant_uid);
            this.$router.push({
              name: "paymentResult",
              params: {
                transactionId: response.merchant_uid,
                msg: response.error_msg
              }
            });
          }
        });
      }
    }
  }
}
</script>

<style scoped>
#paymentContainer {
  font-family: 'Noto Sans KR',serif;
}
#header {
  text-align: center;
}

#dollarImg {
  position: absolute;
  top: 30px;
  left: -450px;
  width: 300.63px;
}

#coinImg {
  position: absolute;
  top: 45px;
  left: -230px;
  width: 73.4px;
}

#plusImg {
  position: absolute;
  top: 15px;
  left: 420px;
  width: 127px;
}

#documentImg {
  position: absolute;
  top: 55px;
  left: 470px;
  width: 198.15px;
}

.orderTypeButton {
  font-size: 16px;
  width: 100px;
  height: 28px;
  color: #E7A64E;
  font-weight: bold;
  margin: 0 5px;
  padding-top:4px;
}

.orderTypeButton:hover {
  cursor: pointer;
}

.clicked {
  font-size: 16px;
  width: 100px;
  height: 28px;
  color: #FFFFFF;
  font-weight: bold;
  background-color: #E7A64E;
  border-radius: 100px;
  padding-top:4px;
}


*:hover {
  cursor: default;
}

.productItemTitle {
  font-weight: bold;
  line-height: 28px;
  width: 100px;
  margin: 0 20px;
  font-size: 16px;
  text-align: left;
}

.productItemDescription {
  font-size: 12px;
  font-weight: 300;
  line-height: 20px;
  width: 220px;
  text-align: left;
}

.servicePaymentButton {
  color: #888888;
  font-size: 14px;
  line-height: 28px;
  height: 28px;
  background-color: #FFFFFF;
  border: 1px solid #E2E3E4;
  border-radius: 100px;
  margin-top: 30.78px;
  margin-bottom: 28px;
  padding: 0 16px;
  box-sizing: content-box;
  display: inline-block;
  text-decoration: none;
}

.servicePaymentButton:hover {
  color: #777777;
  background: #F0F0F0;
  border: 1px solid #E2E3E4;
  border-radius: 100px;
  cursor: pointer;
}

.premiumButton {
  background: #F24E1E;
  color: #FFFFFF;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  margin: 0;
}

.premiumButton:hover {
  background: #D85934;
  border-radius: 100px;
  color: #FFFFFF;
}

.productEnable {
  width: 200px;
  font-size: 24px;
  line-height: 30px;
  padding: 61px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.premiumEnable {
  font-size: 24px;
  color: #F24E1E;
  line-height: 30px;
  font-weight: 700;
}

.divider {
  width:auto;
  border:1px dashed #E2E3E4;
}

.productItemContainer {
  width: 356px;
  display: flex;
  justify-content: center;
  align-items: center;


  border-right:12px solid #F7F8FA;
  box-sizing: content-box;
}

.rightBorder {
  border-right:12px solid #F7F8FA;
  box-sizing: content-box;
}

.productRow > div {
}

.productRow {
  display: flex;
  justify-content: center;
  text-align: center;
  border-top: 1px solid #E2E3E4;
  background: #FBFCFD;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  padding:0;
}

.productPrice {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}







#footer {
  background: #EFEFEF;
  text-align: center;
  display: flex;
  align-items: center;
  justify-items: center;


}

.saleIcon {
  position: absolute;
  top: -55px;
  left: -80px;
  width: 56px;
  height: 56px;
  background: #F24E1E;
  font-weight: 700;
  color:#FFFFFF;
  font-size:24px;
  line-height: 24px;
  text-align: center;
  padding: 8px;
  border-radius: 100%;
}

.saleIcon::after {
  content: '';
  border-right: 20px solid #F24E1E;
  border-bottom: 20px solid #F24E1E;
  position: absolute;
  bottom: 4px;
  right: 4px;
  transform: matrix(-1, 0, 0, 1, 0, 0);
}

.saleIconSmall {
  position: absolute;
  top: -30px;
  left: -40px;
  width: 44px;
  height: 44px;
  background: #F24E1E;
  font-weight: 700;
  color:#FFFFFF;
  font-size:16px;
  line-height: 20px;
  text-align: center;
  padding: 6px;
  border-radius: 100%;
}

.saleIconSmall::after {
  content: '';
  border-right: 14px solid #F24E1E;
  border-bottom: 14px solid #F24E1E;
  position: absolute;
  bottom: 2px;
  right: 2px;
  transform: matrix(-1, 0, 0, 1, 0, 0);
}

.paymentContainer {
  padding: 0;
  font-size: 16px;
  line-height: 21px;
  text-align: center;
  margin: 0 auto;
}

#body {

}

.bodyContainer {
  max-width: 992px;
  padding-top: 14px;
  padding-bottom: 244px;
}

.originalPrice {
  margin-top:34px;
  text-decoration: line-through;
  padding-right:75px;
  color:#888888;
  font-size:16px;
  line-height: 30px;
  font-weight:300
}
.footerContainer {
  font-size: 12px;
  text-align: left;
  padding-top: 72px;
  padding-bottom: 100px;
}

ul {
  list-style: none;
}

li::marker {
  font-size: 6px;
}

.footerContent {
  list-style: inside;
  font-size: 12px;
  padding: 0 2px 0 2px;
}

.footerTitle {
  font-size: 14px;
  font-weight: 600;
  padding: 10px 0 8px 0;
}

.cardTitle {
  font-size: 16px;
  padding-top: 20px;
  margin-left:20px;
  font-weight: 700;
}


.headerContainer {
  padding: 36px 74px;
  margin: 0;
}
.headerTitle {
  padding-bottom: 24px
}

#bodyMobile {
  display: none;
  width: 100%;
}

.personal_price {
  width: 100%;
}

.personal_price:hover{
  cursor: pointer;
}

@media only screen and (max-width: 960px) {

  #dollarImg {
    position: absolute;
    top: 75px;
    left: -250px;
    width: 170px;
    z-index: 10;
  }

  #coinImg {
    position: absolute;
    top: 25px;
    left: -150px;
    width: 73.4px;
  }

  #plusImg {
    position: absolute;
    top: 30px;
    left: 320px;
    width: 100px;
  }

  #documentImg {
    position: absolute;
    top: 75px;
    left: 330px;
    width: 130px;
  }

  #dollarImg,
  #coinImg,
  #plusImg,
  #documentImg {
    display: none;
  }

  #body {
    display: none;
  }

  #bodyMobile {
    display: block;
  }

  #personal_mobile {
    width: 100%;
  }
}

.footerContainer {
  padding: 32px 16px;
  font-size: 8px;
}


</style>
